import { render, staticRenderFns } from "./MedicalSpas.vue?vue&type=template&id=c6511ee0"
import script from "./MedicalSpas.vue?vue&type=script&lang=js"
export * from "./MedicalSpas.vue?vue&type=script&lang=js"
import style0 from "./MedicalSpas.vue?vue&type=style&index=0&id=c6511ee0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports